import React from 'react';
import EmbedCodeGenerator from '../components/EmbedCodeGenerator';

const EmbedPage: React.FC = () => {
  return (
    <div data-testid="embed-section">
      <EmbedCodeGenerator />
    </div>
  );
};

export default EmbedPage;
